var _a;
import { setIsWriterDeviationFeatured as initWriterPopup } from '../../WriterPopup/actions';
import { ModalType } from './types';
export default (_a = {},
    _a[ModalType.JOURNAL] = initWriterPopup,
    _a);
//# sourceMappingURL=initActions.js.map